
// 全局业务常量

// 需要审批KOL，二级需求类型，KOL类型
export const MUST_KOL_APPROVE_ID = ['1110', '2210']

// 三级单需求类型：合作内容KPI必填，且没有common指标
export const COOPERATE_KPI_REQUIRED_CATEGORY_ID = ['221011', '221010']

// 需求类型一级为：效果买量、收口投放、品牌曝光、A+
// 新建需求的时候无需显示采购方式.(同原广告投放）
export const DisablePurchasingMethodType = [10, 19, 20, 21, 27]


export const isNeedPreApprove = ({
                                     purchasing_method
                                 }: {
    purchasing_method: string
}) => {
    // 指定采购和特殊事项采购需要预审
    return ['s_directional_bidding', 's_special_matter_bidding'].includes(purchasing_method);
};

export const isNeedBiding = ({
                                 purchasing_method,
                                 purchasing_strategy
                             }: {
    purchasing_method: string
    purchasing_strategy: string
}) => {
    // 招采
    return purchasing_method === 's_traditional_bidding'
};

export const EXCESS_ACCEPTANCE_NUM = 500;

export const REPORT_URL = 'https://jubao.163.com/';

export enum ORDER_LEVEL_ENUM {
    FIRST = 0,
    SECOND = 1,
    THIRD = 2,
}

export const ORDER_LEVEL_LIST = [
    { name: '一级单', value: ORDER_LEVEL_ENUM.FIRST },
    { name: '二级单', value: ORDER_LEVEL_ENUM.SECOND },
    { name: '三级单', value: ORDER_LEVEL_ENUM.THIRD },
]